import React, { Component } from "react";

class LinkMessage extends Component {
  title = '';

  sendLinkMessage = () => {
    this.props.onSubmitLinkResponse(this.props.title)
  }

  render() {
    return(
      <button
        title={this.props.title}
        className='linkMessage'
        onClick={this.sendLinkMessage}>
        {this.props.title}
      </button>
    )
  }
}

export default LinkMessage
